import styled from "styled-components";

const RootContainer = styled.div`
  background-color: black;
  color: white;
  width: auto;
  border-radius: 8px;
  height: 36px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 10px;
  span {
    font-size: 14px;
    font-weight: bold;
  }
  :hover {
    cursor: pointer;
  }
`;

const modules = {
  RootContainer,
};

export default modules;
